import React, { Suspense, lazy } from 'react';
import HomeSection from '../components/HomeSection';
import LoadingSpinner from '../components/shared/LoadingSpinner';

// Lazy load sections that are below the fold for better performance
const WhyInfinitySection = lazy(() => import('../components/WhyInfinitySection'));
const AboutUsSection = lazy(() => import('../components/AboutusSection'));
const ProblemSolutionSection = lazy(() => import('../components/ProblemSolutionSection'));
const ContactUsSection = lazy(() => import('../components/ContactUsSection'));
const FooterSection = lazy(() => import('../components/FooterSection'));

const LandingPage = () => {
    return (
        <div>
            <div className="flex flex-col min-h-screen">
                <div
  className="snap-y snap-mandatory overflow-y-auto scroll-smooth w-full text-white relative overflow-hidden mx-auto px-4 md:px-20 bg-cover bg-center bg-no-repeat z-[1]"
  style={{ backgroundImage: 'url("/Home8.png")' }}
>
                    {/* Load immediately - above the fold */}
                    <HomeSection />

                    {/* Lazy load below the fold sections with loading spinner */}
                    <Suspense fallback={<LoadingSpinner />}>
                        <WhyInfinitySection />
                    </Suspense>

                    <Suspense fallback={<LoadingSpinner />}>
                        <AboutUsSection />
                    </Suspense>

                    <Suspense fallback={<LoadingSpinner />}>
                        <ProblemSolutionSection />
                    </Suspense>

                   {/* <Suspense fallback={<LoadingSpinner />}>
                        <ContactUsSection />
                    </Suspense>*/}
                </div>

                <Suspense fallback={<LoadingSpinner />}>
                    <FooterSection />
                </Suspense>
            </div>
        </div>
    );
};

export default LandingPage;
